import React from 'react';
import { Button, Typography } from '@mui/material/';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useRebook } from './RebookFlight/RebookContext';

const NskBackButton: React.FC<{
  setDisplayRebookFlight: (value: boolean) => void;
  setActiveFlightMenuButton: (value: string) => void;
}> = ({ setDisplayRebookFlight, setActiveFlightMenuButton }) => {
  const { toggleDisplay, toggleConfirmation, displayFlights, displayConfirmation, resetSearchedDirectionCount } =
    useRebook();

  return (
    <Button
      sx={{ alignSelf: 'self-start', paddingBottom: 3, justifyContent: 'start', paddingLeft: 0 }}
      onClick={() => {
        if (displayFlights) {
          toggleDisplay(false);
          resetSearchedDirectionCount();
        } else if (displayConfirmation) {
          toggleConfirmation(false);
          toggleDisplay(false);
          resetSearchedDirectionCount();
        } else {
          setDisplayRebookFlight(false);
          setActiveFlightMenuButton('');
        }
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '18px',
          width: '18px',
          borderRadius: '9px',
          border: '2px solid #092A5E',
        }}
      >
        <ArrowBackIcon color="primary" sx={{ fontSize: '18px' }} />
      </div>
      <Typography color="primary" variant="h6" style={{ marginLeft: '10px', fontWeight: 400, fontSize: '18px' }}>
        BACK
      </Typography>
    </Button>
  );
};

export default NskBackButton;
